import { useState, useCallback } from 'react'
import { API, API_ROUTER } from '../../../api'
import { toast } from 'react-toastify'

export const useGameManagement = tournament => {
  const [gameNickname, setGameNickname] = useState('')
  const [openMoreInfoModal, setOpenMoreInfoModal] = useState(false)

  const addGame = useCallback(() => {
    const data = {
      gameId: tournament?.game?.id,
      nickname: gameNickname,
    }
    API.request({
      ...API_ROUTER.games.addGameToUserGames,
      data,
    })
      .then(() => {
        toast.success('Game successfully added')
        window.location.reload()
      })
      .catch(() => {
        toast.error('Something went wrong')
      })
  }, [tournament?.game?.id, gameNickname])

  const handleGameNicknameChange = useCallback(e => {
    setGameNickname(e.target.value)
  }, [])

  const toggleMoreInfoModal = useCallback(() => {
    setOpenMoreInfoModal(!openMoreInfoModal)
  }, [openMoreInfoModal])

  return {
    gameNickname,
    openMoreInfoModal,
    addGame,
    handleGameNicknameChange,
    toggleMoreInfoModal,
  }
}
